module.exports = __webpack_public_path__ + "static/frontend-0b2f9f47bce5ef529a14cf9048d5beee.svg";